/**
 * US mobile numbers, the only kind a Runner can be issued a checkout card
 * against. Same normalisation as the public-site relay and the Runner app.
 */
const NANP = /^[2-9]\d{2}[2-9]\d{6}$/;

export function toUsE164(raw: string): string | null {
  const digits = raw.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  return ten.length === 10 && NANP.test(ten) ? `+1${ten}` : null;
}

/** +17045550100 → (704) 555-0100. Anything else is returned unchanged. */
export function formatUsPhone(e164: string | null | undefined): string {
  if (!e164) return '';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}
